'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/ConfirmBox.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _ExtendedButton = require('./ExtendedButton');

var _ExtendedButton2 = _interopRequireDefault(_ExtendedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl}
modal={true} 
MessageText={Vas.Resources.Labels["ConfirmDeleteAccount"]} 
Click={()=>{this.Delete()}}
LabelConfirm={Vas.Resources.Labels["Confirm"]}
LabelCancel={Vas.Resources.Labels["Cancel"]}
optional:
 
*/

//in der ConfirmboxBox wird der User gefragt, ob er eine definierte Operation, z.B. Löschen, wirklich ausführen möchte
var ConfirmBox = function (_Component) {
    _inherits(ConfirmBox, _Component);

    function ConfirmBox(props) {
        _classCallCheck(this, ConfirmBox);

        var _this = _possibleConstructorReturn(this, (ConfirmBox.__proto__ || Object.getPrototypeOf(ConfirmBox)).call(this, props));

        _this.state = {};
        _this.state.Open = false;
        return _this;
    }

    _createClass(ConfirmBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.dragElement(document.getElementById("MessageBox"));
            if (this.props.modal === true) {
                this.toggleModal();
            }

            var me = this;

            (0, _jquery2.default)(document).keyup(function (e) {

                switch (e.which) {
                    case 27:
                        {
                            //ESC
                            me.Close();
                            break;
                        }
                    default:
                        {
                            break;
                        }
                }
            });

            var kontrastNumber = localStorage.getItem('Kontrast');

            if (kontrastNumber == "false") {
                (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr, .selected").attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');

                (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr, .selected").mouseenter(function () {
                    (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
                }).mouseleave(function () {
                    (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
                });
            } else if (kontrastNumber == "true") {
                (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr, .selected").attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');

                (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr, .selected").mouseenter(function () {
                    (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
                }).mouseleave(function () {
                    (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.modal === true) {
                this.toggleModal();
            }
        }
    }, {
        key: 'Close',
        value: function Close() {
            _reactDom2.default.unmountComponentAtNode(document.getElementById('messageContainer'));
            (0, _jquery2.default)("#Content").css("opacity", "1");
        }
    }, {
        key: 'toggleModal',
        value: function toggleModal() {
            var modal = document.querySelector(".modal");
            modal.classList.toggle("show-modal");
        }

        //#region drag&drop

    }, {
        key: 'dragElement',
        value: function dragElement(elmnt) {
            //https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_draggable 08.08.2018
            var pos1 = 0,
                pos2 = 0,
                pos3 = 0,
                pos4 = 0;

            if (document.getElementById(elmnt.id + "Header")) {
                /* if present, the header is where you move the DIV from:*/
                document.getElementById(elmnt.id + "Header").onmousedown = dragMouseDown;
            } else {
                /* otherwise, move the DIV from anywhere inside the DIV:*/
                elmnt.onmousedown = dragMouseDown;
            }

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                // get the mouse cursor position at startup:
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                // call a function whenever the cursor moves:
                document.onmousemove = elementDrag;
            }

            function elementDrag(e) {
                e = e || window.event;
                e.preventDefault();
                // calculate the new cursor position:
                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;

                // set the element's new position:
                elmnt.style.top = elmnt.offsetTop - pos2 + "px";
                elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
            }

            function closeDragElement() {
                /* stop moving when mouse button is released:*/
                document.onmouseup = null;
                document.onmousemove = null;
            }
        }
        //#endregion

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var click = this.props.Click;
            var text = this.props.MessageText;
            var confirmButtonText = this.props.LabelConfirmButton == undefined || this.props.LabelConfirmButton == null ? "OK" : this.props.LabelConfirmButton;

            var className = '';
            if (this.props.modal === true) {
                className = "modal";
            }

            var Style = null;
            var top = null;
            var left = null;
            if (document.getElementById("MessageBox")) {
                top = -(document.getElementById("MessageBox").offsetHeight / 2);
                left = -(document.getElementById("MessageBox").offsetWidth / 2);
            }
            Style = { marginTop: top, marginLeft: left };
            (0, _jquery2.default)("#Content").css("opacity", "0.4");
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    {
                        id: "MessageBox",
                        className: "ConfirmBox",
                        style: Style },
                    _react2.default.createElement(
                        'div',
                        {
                            id: "MessageBoxHeader",
                            className: "ConfirmBoxTitle" },
                        this.props.LabelConfirm,
                        _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "Close",
                            Style: { cursor: 'pointer' },
                            Size: 24,
                            Color: "white",
                            Align: "right",
                            OnClick: function OnClick() {
                                _this2.Close();
                            } })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "ConfirmBoxMessageContainer" },
                        text,
                        ' '
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_ExtendedButton2.default, {
                            Usable: true,
                            Text: this.props.LabelCancel,
                            Width: 150,
                            style: { marginTop: '2px !important' },
                            Float: 'right',
                            OnClick: function OnClick() {
                                _this2.Close();
                            } })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_ExtendedButton2.default, {
                            Usable: true,
                            Text: confirmButtonText,
                            Width: 150,
                            style: { marginTop: '2px !important' },
                            Float: 'right',
                            OnClick: function OnClick() {
                                _this2.Close();if (_this2.props.Click) {
                                    click();
                                }
                            } })
                    )
                )
            );
        }
    }]);

    return ConfirmBox;
}(_react.Component);

exports.default = ConfirmBox;